__turbopack_context__.v({
  "absoluteOverlay": "HeroLoadingFallback-module__kLvcfW__absoluteOverlay",
  "buttonContainer": "HeroLoadingFallback-module__kLvcfW__buttonContainer",
  "flexCenter": "HeroLoadingFallback-module__kLvcfW__flexCenter",
  "flexColumn": "HeroLoadingFallback-module__kLvcfW__flexColumn",
  "hidden": "HeroLoadingFallback-module__kLvcfW__hidden",
  "hiddenPreWrap": "HeroLoadingFallback-module__kLvcfW__hiddenPreWrap",
  "relative": "HeroLoadingFallback-module__kLvcfW__relative",
});
